import { siteMeta } from "@/mocks/crash";

const navLinks = [
  { label: "事件现场", href: "#events" },
  { label: "塌房档案", href: "#types" },
  { label: "崩塌路径", href: "#flow" },
  { label: "深度专题", href: "#deep" },
  { label: "吃瓜手册", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

const hotTags = [
  "人设崩塌",
  "女神塌房",
  "滤镜碎了",
  "形象翻车",
  "完美破灭",
  "幻灭现场",
  "理性吃瓜",
  "人设翻车",
];

export default function Footer() {
  return (
    <footer className="relative bg-paper-200/80 border-t border-paper-300/70">
      <div className="mx-auto max-w-6xl px-4 md:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1.2fr] gap-10">
          <div>
            <a href="#top" className="inline-flex items-center gap-2 cursor-pointer" aria-label="返回首页">
              <span className="grid place-items-center w-9 h-9 rounded-full bg-ink-900 text-paper-50">
                <i className="ri-focus-3-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-display text-lg text-ink-900">{siteMeta.brand}</span>
                <span className="text-[10px] tracking-[0.28em] uppercase text-ink-700/60">
                  {siteMeta.englishLabel}
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm text-ink-700/75 leading-relaxed">
              专注拆解娱乐圈人设崩塌与完美形象幻灭的内容媒体。不造谣、不站队、不审判，
              只做冷静的现象观察与行业剖析。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-bilibili-fill", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="关注我们"
                  className="grid place-items-center w-9 h-9 rounded-full border border-ink-900/15 text-ink-800 hover:bg-ink-900 hover:text-paper-50 transition-colors"
                >
                  <i className={ic}></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="站内导航">
            <h3 className="font-semibold text-ink-900">栏目导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="inline-flex items-center gap-1.5 text-sm text-ink-700/80 hover:text-coral-600 transition-colors"
                  >
                    <i className="ri-arrow-right-s-line text-coral-500"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-semibold text-ink-900">本站关键词</h3>
            <div className="mt-4 flex flex-wrap gap-2">
              {hotTags.map((t) => (
                <a
                  key={t}
                  href="#top"
                  className="rounded-full border border-ink-900/10 bg-paper-50 px-3 py-1.5 text-xs text-ink-800 hover:border-coral-300 hover:text-coral-700 transition-colors"
                >
                  {t}
                </a>
              ))}
            </div>
            <p className="mt-5 text-xs text-ink-700/55 leading-relaxed">
              理性吃瓜提示：本站内容仅供娱乐与现象讨论，请以官方实锤与事实为准，
              勿对任何公众人物进行人身攻击与网暴。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-paper-300/70 pt-6 text-sm text-ink-700/60">
          <p>© {new Date().getFullYear()} {siteMeta.brand} · 本站为内容媒体演示，联系方式均为示例。</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line text-coral-600"></i>
            仅用于内容展示 · 理性看待网络信息
          </p>
        </div>
      </div>
    </footer>
  );
}